<div *ngIf="isPageReady" class="flex flex-col w-full">
  <div class="text-base mb-4">{{ scopeCaption }}</div>

  <!-- Undesignated tree: these settings would apply to every Program sharing this tree, so they
       are withheld and the promotion path is offered instead. -->
  <div *ngIf="!isProgramSpecific" class="mb-2">
    <p class="text-base mb-2">
      Purchase orders, procurement cards and ordering time frames belong to <b>one Program</b>. This tree is shared, so
      a setting made here would apply to every Program using it &mdash; including re-routing another Program's orders to
      the wrong purchase order.
    </p>
    <p class="text-base mb-0">To set them, dedicate this tree to a single Program.</p>
    <div *ngIf="designationNote" class="text-base text-red-500 mt-3">{{ designationNote }}</div>
  </div>

  <div *ngIf="isProgramSpecific" class="flex flex-col gap-4 mb-4">
    <div class="flex flex-row gap-4">
      <div class="w-1/2">
        <prox-field label="Purchase Order">
          <p-select [disabled]="isReadOnly()" [options]="pos" [(ngModel)]="atug.accountPurchaseOrder" [checkmark]="true"
            optionLabel="purchaseOrder" [showClear]="true" placeholder="Select Purchase Order" class="w-full" />
        </prox-field>
      </div>
      <div class="w-1/2">
        <prox-field label="Procurement Card">
          <p-select [disabled]="isReadOnly()" [options]="pcards" [(ngModel)]="atug.accountProcurementCard"
            [checkmark]="true" optionLabel="namedesc" [showClear]="true" placeholder="Select Procurement Card"
            class="w-full" />
        </prox-field>
      </div>
    </div>

    <p-card *ngIf="!isInventoryProgram" header="Restricted Ordering Time Frame">
      <div class="flex flex-row gap-4">
        <div class="w-1/3">
          <prox-field label="Starts After Program Start (Days)">
            <p-inputnumber [disabled]="isReadOnly()" inputId="integeronly" [(ngModel)]="atug.orderTimeFrameStartDays"
              [useGrouping]="false" />
          </prox-field>
        </div>
        <div class="w-1/3">
          <prox-field label="Order Period Duration (Days)">
            <p-inputnumber [disabled]="isReadOnly()" inputId="integeronly" [(ngModel)]="atug.orderTimeFrameDurationDays"
              [useGrouping]="false" />
          </prox-field>
        </div>
        <div class="w-1/3">
          <prox-field label="Ship Date After Order Start (Days)">
            <p-inputnumber [disabled]="isReadOnly()" inputId="integeronly"
              [(ngModel)]="atug.orderTimeFrameShipByFromStartDays" [useGrouping]="false" />
          </prox-field>
        </div>
      </div>
    </p-card>
  </div>

  <div class="flex pt-3 items-center gap-2">
    <p-button *ngIf="!isReadOnly() && isProgramSpecific" [disabled]="!canSave()" (onClick)="onSave()" label="Save"
      icon="pi pi-check"></p-button>
    <p-button *ngIf="!isReadOnly() && !isProgramSpecific" (onClick)="onMakeProgramSpecific()" [disabled]="isDesignating"
      label="Make This a Program-Specific Tree" icon="fa-duotone fa-code-branch"></p-button>
    <p-button (onClick)="onCancel()" [label]="cancelLabel()" icon="pi pi-times" [outlined]="true"></p-button>
  </div>
</div>
